interface IconProps {
	className?: string;
}

export const QuestsIcon = ({ className = 'inline-block h-5 w-5' }: IconProps) => {
	return (
		<svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M17.4037 12.9571V6.19361C17.4037 5.1025 16.7639 4.5 15.3147 4.5H4.80809M4.80809 4.5C2.23808 4.5 2.31098 8.17326 4.80809 8.17326H6.50323M4.80809 4.5C5.8485 4.5 6.50323 5.29088 6.50323 5.87664V8.17326M6.50323 8.17326V17.1957C6.50323 18.7021 7.45626 19.0615 8.22307 19.0615M8.22307 19.0615H17.7862C19.7526 19.0615 21.0922 16.6927 21.0922 15.5225H12.0322C12.0322 16.9884 10.3839 19.0615 8.22307 19.0615Z"
				stroke="currentColor"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
